import React from 'react';
import { Calendar, Image, Edit2, Trash2 } from 'lucide-react';

export const AlbumCard = ({ album, onSelect, onEdit, onDelete, formatDate }) => {
  return (
    <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden hover:border-purple-500/50 transition-colors">
      <div className="relative h-40 bg-gray-900 cursor-pointer" onClick={onSelect}>
        {album.cover_image ? (
          <img src={album.cover_image} alt={album.name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Image size={48} className="text-gray-600" />
          </div>
        )}
        <div className="absolute bottom-2 right-2 bg-black/70 text-white px-2 py-1 rounded text-xs">
          {album.photos?.length || 0} photos
        </div>
      </div>
      <div className="p-4 space-y-2">
        <h4 className="font-semibold text-purple-400 cursor-pointer hover:text-purple-300" onClick={onSelect}>
          {album.name}
        </h4>
        <div className="flex items-center gap-2 text-gray-500 text-sm">
          <Calendar size={14} />
          <span>{formatDate(album.date)}</span>
        </div>
        {album.description && <p className="text-sm text-gray-400 line-clamp-2">{album.description}</p>}
        <div className="flex items-center justify-between pt-2 border-t border-gray-700">
          <button onClick={onSelect} className="text-purple-400 hover:text-purple-300 text-sm font-medium">
            Manage Photos &rarr;
          </button>
          <div className="flex gap-2">
            <button onClick={onEdit} className="text-blue-400 hover:text-blue-300"><Edit2 size={18} /></button>
            <button onClick={onDelete} className="text-red-400 hover:text-red-300"><Trash2 size={18} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};
